<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" [ngClass]="{ expanded: displayMode === DisplayMode.Form }" hideToggle class="panel-list">
        <mat-expansion-panel-header
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            collapsedHeight="48px"
            expandedHeight="48px"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Modèles de mails"
                createIconText="Ajouter un modèle"
                importDatasourceName="emailtemplates"
                (created)="onEmailTemplateCreated()"
                (exported)="onEmailTemplateExported()"
                (imported)="onEmailTemplateImported()"
                (helped)="onEmailTemplateHelped()"></app-list-header>
        </mat-expansion-panel-header>

        <app-emails-templates-list
            #itemsList
            [global]="global"
            (itemSelected)="onEmailTemplateSelected($event)"
            (itemDisplayed)="onEmailTemplateDisplayed($event)"
            (itemEdited)="onEmailTemplateEdited($event)"
            (itemDeleted)="onEmailTemplateDeleted($event)"
            (itemDuplicated)="onEmailTemplateDuplicated($event)"></app-emails-templates-list>
    </mat-expansion-panel>
    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.formContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (displayed)="onEmailTemplateDisplayed(context?.formContext.item)"
                    (edited)="onEmailTemplateEdited(context?.formContext.item)"
                    (helped)="onEmailTemplateHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-email-template-detail [context]="context" (emailTemplateUpdated)="onEmailTemplateUpdated($event)" (canceled)="onBackToList()"></app-email-template-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
